( function () {
	'use strict';

	// Usage: <button class="btn btn-default" pdf-preview-btn pdf-url="INSERT PDF URL" pdf-name="INSERT TITLE PDF">Preview</button>
	function pdfPreviewBtn ( $modal ) {
		function openPdfPreviewModal ( pdfUrl, pdfName, hasData ) {
			$modal.open( {
				'templateUrl'      : '/templates/components/pdf-viewer/pdf-preview.html',
				'controller'       : 'pdfPreviewCtrl',
				'controllerAs'     : 'vm',
				'size'             : 'lg',
				'bindToController' : true,
				'resolve'          : {
					'pdfDetails' : function () {
						return {
							'pdfUrl'  : pdfUrl,
							'pdfName' : pdfName,
							'hasData' : hasData
						};
					}
				}
			} );
		}

		return {
			'restrict' : 'A',
			'scope'    : {
				'pdfUrl'      : '@',
				'pdfName'     : '@',
				'generatePdf' : '&'
			},

			'link' : function ( scope, element ) {
				element.on( 'click', function () {
					element.attr( 'disabled', true );
					scope.generatePdf()( function ( pdfUrl ) {
						openPdfPreviewModal( pdfUrl, scope.pdfName, true );
						element.attr( 'disabled', false );
					} );
				} );
			}
		};
	}

	angular
		.module( 'app.report' )
		.directive( 'pdfPreviewBtn', pdfPreviewBtn );

	pdfPreviewBtn.$inject = [ '$modal' ];
} )( );
